<div class="row">
  <div class="col-md-12">
    <h5 class="card-title">Mis Paquetes</h5>
    <p>A continuación, podrá ver los paquetes que ha adquirido</p>
    <hr class="linea" />
  </div>
</div>

<div class="row">
  <div class="col-12 col-md-8">
    @for (data of listadoPaquetes; track $index) {
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm order-2 order-sm-1">
            <div class="d-flex align-items-start mt-3 mt-sm-0">
              <div class="flex-grow-1">
                <div>
                  <h3 class="f mb-1 text-primary">
                    {{ data.idServicio.servicio }}
                  </h3>

                  <span
                    class="badge {{ data.estadoPago?.clase }} font-size-12 mb-2"
                  >
                    {{ data.estadoPago?.texto }}
                  </span>

                  <h6>
                    <small class="text-muted me-2 font-size-13"
                      ><i class="fas fa-tags"></i> Total sesiones -
                      {{ data.idServicio.cantidad_citas }}</small
                    >
                  </h6>
                  <h5>
                    <small class="text-muted me-2 font-size-13"
                      >Tipo de terapia:</small
                    >
                    <strong>{{ data.idServicio.tTerapia.terapia }}</strong>
                  </h5>
                  <h5>
                    <small class="text-muted me-2 font-size-13"
                      >Dirigido a:</small
                    >
                    <strong>{{ data.idServicio.tDirigido.dirigido }}</strong>
                  </h5>

                  <h5>
                    <small class="text-muted me-2 font-size-13"
                      >Duración de la sesión:
                    </small>
                    <strong
                      ><i class="fas fa-history"></i>
                      {{ data.idServicio.duracion }} Minutos</strong
                    >
                  </h5>
                  <h5>
                    <small class="text-muted me-2 font-size-13"
                      >Modalidad:
                    </small>
                    {{ data.idServicio.modalidad }}
                  </h5>
                  <hr />
                  <div
                    class="d-flex flex-wrap align-items-start gap-2 gap-lg-3 text-muted font-size-14"
                  >
                    <div>
                      <i
                        class="mdi mdi-circle-medium me-1 text-success align-middle"
                      ></i>
                      Fecha de compra:
                      <strong>
                        {{ convertToLocal(data.fCompra) | date : "dd/MM/yyyy" }}
                      </strong>
                    </div>
                    <div>
                      <i
                        class="mdi mdi-circle-medium me-1 text-success align-middle"
                      ></i>
                      Sesiones restantes:
                      <strong>{{ data.citasRestantes }}</strong>
                    </div>
                    @if (data.pagoPaquete?.fechaPago) {
                    <div>
                      <i
                        class="mdi mdi-circle-medium me-1 text-success align-middle"
                      ></i>
                      Fecha de pago:
                      <strong>
                        {{
                          convertToLocal(data.pagoPaquete.fechaPago)
                            | date : "dd/MM/yyyy"
                        }}
                      </strong>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-auto order-1 order-sm-2">
            <div class="text-sm-end">
              @if(userLocal){
              <h3 class="mb-1">
                <small><i class="fas fa-wallet text-info"></i> Valor: </small>
                <br />

                <small class="text-muted fw-normal">COP </small
                >{{ data.idServicio.valorCop | number : "1.2-2" }}
              </h3>
              }@else{
              <h3 class="mb-1">
                <small><i class="fas fa-wallet text-info"></i> Valor: </small>
                <br />
                <small class="text-muted fw-normal">USD </small
                >{{ data.idServicio.valorCop | number : "1.2-2" }}
              </h3>
              }
            </div>
          </div>
        </div>
      </div>
      <!-- end card body -->
    </div>
    <!-- end card -->
    }
  </div>
</div>
